var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconUploadPhoto48Line = function SvgIconUploadPhoto48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.4 8.3H19.6a5.31 5.31 0 0 0-5.3 5.3v14.8c0 2.92 2.38 5.3 5.3 5.3h14.8c2.92 0 5.3-2.38 5.3-5.3V13.6c0-2.92-2.38-5.3-5.3-5.3Zm1.9 20.1a1.9 1.9 0 0 1-1.9 1.9H19.6a1.9 1.9 0 0 1-1.9-1.9V13.6c0-1.05.85-1.9 1.9-1.9h14.8c1.05 0 1.9.85 1.9 1.9v14.8Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1 21.04a2.57 2.57 0 0 0-2.24-1.32c-.93 0-1.79.5-2.24 1.32l-1.46 2.62-.59-.88a2.567 2.567 0 0 0-2.13-1.14c-.86 0-1.65.43-2.13 1.14l-1.24 1.86c-.53.79-.57 1.79-.13 2.63.45.83 1.31 1.35 2.26 1.35h9.75c.92 0 1.74-.47 2.21-1.26.46-.79.48-1.74.03-2.54l-2.1-3.78h.01Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7 34.4V16H8.3v18.4c0 2.92 2.38 5.3 5.3 5.3H32v-3.4H13.6a1.9 1.9 0 0 1-1.9-1.9Z",
    fill: "current"
  })));
};
export default SvgIconUploadPhoto48Line;